import { render, staticRenderFns } from "./Behavior.vue?vue&type=template&id=51c4a0ae&scoped=true&"
import script from "./Behavior.vue?vue&type=script&lang=js&"
export * from "./Behavior.vue?vue&type=script&lang=js&"
import style0 from "./Behavior.vue?vue&type=style&index=0&id=51c4a0ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c4a0ae",
  null
  
)

export default component.exports